import React, { useEffect } from "react";

const SFRedirect = ({ redirectUrl }) => {
  useEffect(() => {
     
    window.location.href = redirectUrl;
  }, []);
  return <div></div>;
};

export default SFRedirect;
